import { configureStore } from '@reduxjs/toolkit'

import groupConditionReducer, { GroupConditionState } from './groupConditionsSlice'

const store = configureStore({
    reducer: {
        groupConditions: groupConditionReducer,
    },
    devTools: false,
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const createStore = ({ groupConditions }: { groupConditions: GroupConditionState }) =>
    configureStore({
        reducer: {
            groupConditions: groupConditionReducer,
        },
        preloadedState: {
            groupConditions,
        },
        devTools: false,
    })